import React from 'react';
import { GraduationCap } from 'lucide-react';
interface BrandMarkProps {
  size?: 'sm' | 'md' | 'lg';
  withText?: boolean;
  className?: string;
}
const sizes = {
  sm: {
    box: 'h-9 w-9',
    icon: 'h-4 w-4',
    title: 'text-sm',
    sub: 'text-[10px]'
  },
  md: {
    box: 'h-11 w-11',
    icon: 'h-5 w-5',
    title: 'text-base',
    sub: 'text-[11px]'
  },
  lg: {
    box: 'h-14 w-14',
    icon: 'h-7 w-7',
    title: 'text-xl',
    sub: 'text-xs'
  }
} as const;
export function BrandMark({
  size = 'md',
  withText = true,
  className = ''
}: BrandMarkProps) {
  const scale = sizes[size];
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-56" data-mp="1hazrfb249il1">
      <span className={`relative grid ${scale.box} shrink-0 place-items-center rounded-2xl brand-gradient text-white shadow-lg shadow-indigo-500/25`} data-id="element-57" data-mp="1cgvl8u0odel0">
        <GraduationCap className={scale.icon} strokeWidth={2.2} data-id="element-58" data-mp="24z0x8c7wukwr" />
        <span className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-white/30" data-id="element-59" data-mp="250keo65az204" />
      </span>
      {withText && <span className="min-w-0 leading-tight" data-id="element-60" data-mp="13vfpmjgws48h">
          <span className={`block truncate font-semibold tracking-tight text-foreground ${scale.title}`} data-id="element-61" data-mp="13vphkcliklgt">
            Student Recorder
          </span>
          <span className={`block truncate font-medium uppercase tracking-[0.18em] text-muted-foreground ${scale.sub}`} data-id="element-62" data-mp="u5np78m4ogw3">
            Paulin Dev Studio
          </span>
        </span>}
    </div>;
}